// eslint-disable-next-line no-use-before-define
import React from "react";
import { Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { OrigoAuthenticator } from "@oriola-origo/origo-app-shell";
import { StylesProvider } from "@material-ui/core";
import NotFound from "./components/404/404";
import Layout from "./components/layout";
import Paths from "./utils/navigation/navigation";
import { PharmaCompany, CompensationRules } from "./components/pharmaCompany";
import Pharmacy from "./components/pharmacy";
import Oriola from "./components/oriolaAdmin";
import { ViewManager, ProtectedRoute, Permission } from "./components/auth";
import { userSignIn, fetchUserDataFromOrigo, userSignOut } from "./redux";

function App() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const { userData } = user;
  const { i18n } = useTranslation();

  const initData = signInData => {
    dispatch(userSignIn(signInData));

    const { userId } = signInData.userData;
    dispatch(fetchUserDataFromOrigo(userId)).then(origoUserData => {
      if (origoUserData?.language) {
        i18n.changeLanguage(origoUserData.language);
      }
    });
  };

  const renderApp = () => (
    <Layout>
      <StylesProvider injectFirst>
        <Routes>
          <Route
            path={Paths.PharmaCompany}
            element={
              <ProtectedRoute
                user={userData}
                failComponent={<NotFound />}
                requiredPermission={Permission.PHARMA_COMPANY_VIEW}
              >
                <PharmaCompany />
              </ProtectedRoute>
            }
          />
          <Route
            path={Paths.Pharmacy}
            element={
              <ProtectedRoute
                user={userData}
                failComponent={<NotFound />}
                requiredPermission={Permission.PHARMACY_VIEW}
              >
                <Pharmacy />
              </ProtectedRoute>
            }
          />
          <Route
            path={Paths.Oriola}
            element={
              <ProtectedRoute
                user={userData}
                failComponent={<NotFound />}
                requiredPermission={Permission.ORIOLA_VIEW}
              >
                <Oriola />
              </ProtectedRoute>
            }
          />
          <Route
            path={Paths.CompensationRules}
            element={
              <ProtectedRoute
                user={userData}
                failComponent={<NotFound />}
                requiredPermission={Permission.PHARMA_COMPANY_VIEW}
              >
                <CompensationRules />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<ViewManager />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </StylesProvider>
    </Layout>
  );

  const renderAuthApp = () => (
    <OrigoAuthenticator
      isSignedIn={user.signedIn}
      onSignedIn={signInData => initData(signInData)}
      onSignedOut={() => {
        dispatch(userSignOut());
      }}
    >
      {renderApp()}
    </OrigoAuthenticator>
  );

  return renderAuthApp();
}

export default App;
